import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ILoggerNoiseSpectrum } from '@app/api/interfaces/chart-data/logger-noise-spectrum';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export enum FpLoggerNoiseSpectrumActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  GetDataError = 'GetDataError',
  ToggleChartFullscreen = 'ToggleChartFullscreen',
}

export interface FpLoggerNoiseSpectrumActionGetData {
  type: FpLoggerNoiseSpectrumActionType.GetData;
  date: string | null;
  popupMainData: ILdLogger | null;
}

export interface FpLoggerNoiseSpectrumActionGetDataSuccesses {
  type: FpLoggerNoiseSpectrumActionType.GetDataSuccesses;
  date: string | null;
  popupMainData: ILdLogger | null;
  data: ILoggerNoiseSpectrum[] | null;
}

export interface FpLoggerNoiseSpectrumActionGetDataError {
  type: FpLoggerNoiseSpectrumActionType.GetDataError;
  date: string | null;
  popupMainData: ILdLogger | null;
  error: IApiBaseErrorResponse;
}

export interface FpLoggerNoiseSpectrumActionToggleChartFullscreen {
  type: FpLoggerNoiseSpectrumActionType.ToggleChartFullscreen;
  synchronizeWithPopupId?: string;
}

export type FpLoggerNoiseSpectrumActions =
  | FpLoggerNoiseSpectrumActionGetData
  | FpLoggerNoiseSpectrumActionGetDataSuccesses
  | FpLoggerNoiseSpectrumActionGetDataError
  | FpLoggerNoiseSpectrumActionToggleChartFullscreen;
